import { memo, useRef } from "react"
import { cx } from "@emotion/css"
import { styles, getPrefixedClassNames as pfcn } from "./styles"
import { useTableContext } from "./context"
import { GridCell } from "./GridCell"
import { Area } from "./types"
import { HoverCell } from "./HoverCell"

type GridRowProps = {
  area: Area
  id: string
  index: number
  start: number
}

export const GridRow = memo(function ({
  area,
  id,
  index,
  start,
}: GridRowProps) {
  const ref = useRef<HTMLDivElement | null>(null)

  const {
    columnManager: cm,
    getRowProps,
    hoveredRow,
    onRowHover,
    rowHoverActions,
  } = useTableContext()

  const { className } = getRowProps(index, id)

  const renderHoverCellHere =
    rowHoverActions && (area === "fixed" || !cm.hasFixedColumns)

  return (
    <>
      <div
        data-area={area}
        role="row"
        ref={ref}
        className={cx(
          styles.row,
          className,
          pfcn("body-row", `body-row--${area}`),
          { [pfcn("body-row--hovered")]: hoveredRow === index },
        )}
        style={{
          transform: `translateY(calc(${start}px + var(--header-height)))`,
        }}
        onMouseEnter={onRowHover ? () => onRowHover(index, true) : undefined}
        onMouseLeave={onRowHover ? () => onRowHover(index, false) : undefined}
      >
        {cm.getColumnsByArea(area).map((column) => (
          <GridCell
            key={area + index + column.id}
            rowIndex={index}
            rowId={id}
            columnId={column.id}
          />
        ))}
      </div>
      {renderHoverCellHere ? (
        <HoverCell
          open={hoveredRow === index}
          rowRef={ref}
          rowId={id}
          rowIndex={index}
          renderer={rowHoverActions!}
        />
      ) : null}
    </>
  )
})
